export default {
    url: 'news',
    include: ['us', 'za', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es'],
};
